import {Component, EnvironmentInjector, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ConfigService} from '@shared-library';
import {ConnectHelper} from "../../utils/connect-helper";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-health-system-connecting',
    templateUrl: './health-system-connecting.component.html',
    styleUrls: ['./health-system-connecting.component.css'],
    standalone: false
})
export class HealthSystemConnectingComponent implements OnInit, OnDestroy {
  @Input() brandId: string = "";
  @Input() portalId: string = "";
  @Input() endpointId: string = "";

  @Input() orgConnectionId?: string = "";
  @Input() externalId?: string = "";
  @Input() externalState?: string = "";
  @Input() vaultProfileConnectionId?: string = "";

  private connectHelperSubscription?: Subscription;


  constructor(
    public configService: ConfigService,
    private router: Router,
    private injector: EnvironmentInjector
  ){}

  ngOnDestroy(): void {
    this.connectHelperSubscription?.unsubscribe();
  }

  ngOnInit(): void {

    this.injector.runInContext(() => {
      this.connectHelperSubscription = ConnectHelper({
        public_id: this.configService.systemConfig$.publicId,
        brand_id: this.brandId,
        portal_id: this.portalId,
        endpoint_id: this.endpointId,
        org_connection_id: this.orgConnectionId,
        external_id: this.externalId,
        external_state: this.externalState,
        vault_profile_connection_id: this.vaultProfileConnectionId,
      })
    })
  }

  cancelAccountConnect(){
    this.router.navigateByUrl('dashboard/accounts')
  }
}
